import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'facade-homes-dialog',
  templateUrl: './facade-homes-dialog.component.html',
  styleUrls: ['./facade-homes-dialog.component.less']
})
export class FacadeHomesDialogComponent {
  selectedCount: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FacadeHomesDialogData,
    private dialogRef: MatDialogRef<FacadeHomesDialogComponent, FacadeHomeMatch[]>) {
    this.updateSelectedCount();
  }

  toggle(match: FacadeHomeMatch) {
    match.selected = !match.selected;
    this.updateSelectedCount();
  }

  setAll(selected: boolean) {
    this.data.matches.forEach(x => x.selected = selected);
    this.updateSelectedCount();
  }

  confirm() {
    this.dialogRef.close(this.data.matches.filter(x => x.selected));
  }

  private updateSelectedCount() {
    this.selectedCount = this.data.matches.filter(x => x.selected).length;
  }
}

export interface FacadeHomesDialogData {
  masterFile: string;
  options: string[];
  matches: FacadeHomeMatch[];
}

export interface FacadeHomeMatch {
  homeName: string;
  masterFile: string;
  options: string[];
  missingOptions: string[];
  isCurrentHome: boolean;
  isPlaceholder: boolean;
  selected: boolean;
}
